import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-806",
  "use": "icon-806-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" class=\"qi-806\" viewBox=\"0 0 16 16\" id=\"icon-806\">\n  <path d=\"M8 0a8.031 8.031 0 0 0-1.065.079 7.992 7.992 0 0 0-.354 15.788h.001A7.952 7.952 0 0 0 8 16 8 8 0 0 0 8 0zM1 8a7.008 7.008 0 0 1 6.204-6.951A25.25 25.25 0 0 1 8 7.5a24.131 24.131 0 0 1-1.067 7.41A7.005 7.005 0 0 1 1 8z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol